import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { UnsavedChangesDialogService } from '../services/unsaved-changes-dialog.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean;
}

export const pendingChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = (component) => {
  const unsavedChangesDialogService = inject(UnsavedChangesDialogService);

  if (component.canDeactivate()) {
    return true;
  }

  return unsavedChangesDialogService.confirm();
};
